var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditGroupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3725 4.31367L4.26138 15.4248C4.14746 15.5387 4.06664 15.6814 4.02757 15.8377L3.13868 19.3933C2.97593 20.0443 3.56561 20.634 4.21661 20.4712L7.77217 19.5823C7.92846 19.5433 8.0712 19.4625 8.18512 19.3485L19.2962 8.23742C19.9971 7.53651 20.2709 6.51491 20.0143 5.55745C19.7578 4.59999 19.0099 3.85213 18.0525 3.59558C17.095 3.33903 16.0734 3.61276 15.3725 4.31367ZM17.5923 5.31278C17.9363 5.40495 18.205 5.67361 18.2971 6.01757L18.3228 6.14737C18.3623 6.45149 18.2595 6.76002 18.0392 6.98034L7.10303 17.9159L5.22203 18.3869L5.69303 16.5059L16.6296 5.57075C16.8499 5.35043 17.1584 5.2476 17.4625 5.28708L17.5923 5.31278ZM20.8899 19.6089C20.8899 19.118 20.4919 18.72 20.001 18.72H12.001L11.8895 18.7269C11.4512 18.7818 11.1121 19.1557 11.1121 19.6089C11.1121 20.0998 11.5101 20.4978 12.001 20.4978H20.001L20.1125 20.4908C20.5508 20.436 20.8899 20.062 20.8899 19.6089Z",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGroupIcon);
export default __webpack_public_path__ + "static/media/edit-group-icon.f4267a7949bd436be723b379af8d1860.svg";
export { ForwardRef as ReactComponent };